<template lang='pug' src='./our-team.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Header from 'components/header/header'
import Footer from 'components/footer/footer'

export default {
  name: 'our-team',
  computed: {
    props () {
      return this.$store.state.pages['our-team']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    Header,
    Footer
  }
}
</script>



// WEBPACK FOOTER //
// our-team.vue?65c1155a